import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-88750b5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid py-3 page-main-title" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col text-center page-main-title" }
const _hoisted_4 = { class: "white-text" }
const _hoisted_5 = { class: "d-flex flex-column container-submissions py-3" }
const _hoisted_6 = { class: "fs-24 fw-bold text-black mt-3" }
const _hoisted_7 = { class: "d-flex flex-column form-container p-2 fs-7" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "mt-4 text-black" }
const _hoisted_11 = { class: "mb-2 fs-6" }
const _hoisted_12 = { class: "mb-2 fs-14-px" }
const _hoisted_13 = { class: "mb-2 fs-14-px" }
const _hoisted_14 = { class: "mb-2 fs-14-px" }
const _hoisted_15 = { class: "mb-2 fs-14-px" }
const _hoisted_16 = { class: "mb-2 fs-14-px" }
const _hoisted_17 = { class: "mb-2 fs-14-px" }
const _hoisted_18 = { class: "mb-2 fs-14-px" }
const _hoisted_19 = {
  class: "collapse",
  id: "collapseExample"
}
const _hoisted_20 = { class: "card card-body card-spiecial-style" }
const _hoisted_21 = { class: "mb-2 fs-6 text-black" }
const _hoisted_22 = { class: "mb-2 fs-6 text-black" }
const _hoisted_23 = { class: "mb-2 fs-6 text-black" }
const _hoisted_24 = { class: "mb-2 fs-6 text-black" }
const _hoisted_25 = { class: "mb-2 fs-6 text-black" }
const _hoisted_26 = { class: "mb-2 fs-6 text-black" }
const _hoisted_27 = { class: "mb-2 fs-6 text-black" }
const _hoisted_28 = { class: "submissions-container p-1" }
const _hoisted_29 = { class: "poster-avatar me-3" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "poster-name" }
const _hoisted_32 = { class: "descripsion-sub my-1" }
const _hoisted_33 = { class: "submission-date" }
const _hoisted_34 = { class: "d-flex justify-content-center" }
const _hoisted_35 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_tips = _resolveComponent("error-tips")!
  const _component_success_tips = _resolveComponent("success-tips")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.local.titleSubmissionsPage), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString($setup.local.formSubmissionTitle), 1),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("textarea", {
          name: "descrip",
          class: "border-1 text-area-content p-1",
          ref: "input1",
          onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.autoResize($setup.input1))),
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.description) = $event)),
          placeholder: $setup.local.desSubmission
        }, null, 40, _hoisted_8), [
          [
            _vModelText,
            $setup.description,
            void 0,
            { trim: true }
          ]
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(["submit-content-btn align-self-end mt-2 p-2", [$setup.state.submitting? 'submitting-btn-mode' : '']]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.submitSubmission())),
          disabled: $setup.state.submitting
        }, _toDisplayString($setup.local.submit), 11, _hoisted_9)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString($setup.local.submissionsIns1), 1),
        _createElementVNode("div", _hoisted_12, _toDisplayString($setup.local.submissionsIns2), 1),
        _createElementVNode("div", _hoisted_13, _toDisplayString($setup.local.submissionsIns3), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString($setup.local.submissionsIns4), 1),
        _createElementVNode("div", _hoisted_15, _toDisplayString($setup.local.submissionsIns5), 1),
        _createElementVNode("div", _hoisted_16, _toDisplayString($setup.local.submissionsIns6), 1),
        _createElementVNode("div", _hoisted_17, _toDisplayString($setup.local.submissionsIns7), 1),
        _createElementVNode("div", _hoisted_18, _toDisplayString($setup.local.submissionsIns8), 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary collapseButton",
        ref: "collapseButton",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.toggleTextBtn && $setup.toggleTextBtn(...args))),
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#collapseExample",
        "aria-expanded": "false",
        "aria-controls": "collapseExample"
      }, _toDisplayString($setup.state.openedContent ? $setup.local.expandedTextBtn : $setup.local.notExpandedTextBtn), 513),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString($setup.local.submissionExp1), 1),
          _createElementVNode("div", _hoisted_22, _toDisplayString($setup.local.submissionExp2), 1),
          _createElementVNode("div", _hoisted_23, _toDisplayString($setup.local.submissionExp3), 1),
          _createElementVNode("div", _hoisted_24, _toDisplayString($setup.local.submissionExp4), 1),
          _createElementVNode("div", _hoisted_25, _toDisplayString($setup.local.submissionExp5), 1),
          _createElementVNode("div", _hoisted_26, _toDisplayString($setup.local.submissionExp6), 1),
          _createElementVNode("div", _hoisted_27, _toDisplayString($setup.local.submissionExp7), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.submissions, (submission, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["submission d-flex", [$setup.state.loadingFeatures ? 'animation-icon' : '']]),
            key: index
          }, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("img", {
                src: submission?.image,
                alt: "avatar",
                onError: _cache[4] || (_cache[4] = ($event: any) => ($setup.onIconMsgFaild($event)))
              }, null, 40, _hoisted_30)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(submission?.username), 1),
              _createElementVNode("pre", _hoisted_32, _toDisplayString(submission?.description), 1),
              _createElementVNode("div", _hoisted_33, _toDisplayString($setup.convertDate(submission?.createdAt)), 1)
            ])
          ], 2))
        }), 128)),
        _withDirectives(_createElementVNode("div", { class: "submission" }, _toDisplayString($setup.local.noSubmissions), 513), [
          [_vShow, !$setup.submissions.length]
        ]),
        _createElementVNode("div", _hoisted_34, [
          _withDirectives(_createElementVNode("button", {
            class: _normalizeClass(["show-more-btn", [$setup.state.loadingMore? 'submitting-btn-mode': '']]),
            disabled: $setup.state.loadingMore,
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showMoreRecords()))
          }, _toDisplayString($setup.local.loading_more) + _toDisplayString($setup.state.loadingMore? '...':''), 11, _hoisted_35), [
            [_vShow, $setup.isMore]
          ])
        ])
      ])
    ]),
    _createVNode(_component_error_tips, { ref: "errorRef" }, null, 512),
    _createVNode(_component_success_tips, { ref: "successRef" }, null, 512)
  ], 64))
}